// extracted by mini-css-extract-plugin
export default {"suggest":"Suggest-module__suggest--YpJSt","wrapper":"Suggest-module__wrapper--rHCH1"};